var localPageData = {
  props: {
    localPageData: {
      type: Object,
      required: false
    }
  },
  computed: {
    pageData: function pageData() {
      return this.localPageData || this.$xp.content.pageData;
    }
  }
};

var entry = {
  mixins: [localPageData],
  props: {
    entryData: {
      type: Object,
      required: true
    }
  }
};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  props: ['entityData'],
  computed: {
    imageUrl: function imageUrl() {
      return this.$xp.content.getImageUrl(this.entityData.Image);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-news-entity" }, [
    _c("div", { staticClass: "c-news-entity__image" }, [
      _vm.entityData.Image.BinaryID
        ? _c("img", {
            attrs: { src: _vm.imageUrl, title: _vm.entityData.Image.Alt }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.entityData.Image.Caption.length > 0
        ? _c("div", { staticClass: "c-news-entity__image-caption" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.entityData.Image.Caption) +
                "\n        "
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-news-entity_meta" }, [
      _c("span", [
        _c("i", { staticClass: "xp xp-calendar" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm._f("dateString")(_vm.entityData.Date)))])
      ]),
      _vm._v(" "),
      _vm.entityData.ShowTime
        ? _c("span", [
            _c("i", { staticClass: "xp xp-clock-o" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("timeString")(_vm.entityData.Date)))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.entityData.Location.length > 0
        ? _c("span", [
            _c("i", { staticClass: "xp xp-map-marker" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.entityData.Location))])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "c-news-entity__teaser",
      domProps: { innerHTML: _vm._s(_vm.entityData.Teaser) }
    })
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  props: ['entityData'],
  computed: {
    imageUrl: function imageUrl() {
      return this.$xp.content.getImageUrl(this.entityData.Image);
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "c-event-entity" }, [
    _c("div", { staticClass: "c-event-entity__image" }, [
      _vm.entityData.Image.BinaryID
        ? _c("img", {
            attrs: { src: _vm.imageUrl, title: _vm.entityData.Image.Alt }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.entityData.Image.Caption.length > 0
        ? _c("div", { staticClass: "c-event-entity__image-caption" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.entityData.Image.Caption) +
                "\n        "
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-event-entity_meta" }, [
      _c("div", { staticClass: "c-event-entity_date" }, [
        _c("i", { staticClass: "xp xp-calendar" }),
        _vm._v(" "),
        _c("span", [
          _vm._v(_vm._s(_vm._f("dateString")(_vm.entityData.StartDate)))
        ]),
        _vm._v(" - "),
        _c("span", [
          _vm._v(_vm._s(_vm._f("dateString")(_vm.entityData.EndDate)))
        ])
      ]),
      _vm._v(" "),
      _vm.entityData.ShowTime
        ? _c("div", [
            _c("i", { staticClass: "xp xp-clock-o" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("timeString")(_vm.entityData.StartDate)))
            ]),
            _vm._v(" - "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("timeString")(_vm.entityData.EndDate)))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.entityData.Location.length > 0
        ? _c("div", [
            _c("i", { staticClass: "xp xp-map-marker" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.entityData.Location))])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "c-event-entity__teaser",
      domProps: { innerHTML: _vm._s(_vm.entityData.Teaser) }
    })
  ])
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

//
var script$2 = {
  mixins: [entry],
  computed: {
    entityComponent: function entityComponent() {
      switch (this.entryData.Entity.Class) {
        case 'News':
          return 'news-entity';

        case 'Event':
          return 'event-entity';

        default:
          throw new Error("entity class \"".concat(this.entryData.Entity.Class, "\" is not supported"));
      }
    },
    isOwnPage: function isOwnPage() {
      return this.entryData.Json.EntityPageID === 0;
    }
  },
  components: {
    NewsEntity: __vue_component__,
    EventEntity: __vue_component__$1
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "js-entry o-entry c-entity-entry" },
    [
      _c(_vm.entityComponent, {
        tag: "component",
        attrs: { entityData: _vm.entryData.Entity }
      }),
      _vm._v(" "),
      !_vm.isOwnPage
        ? _c(
            "div",
            { staticClass: "c-entity-entry__more-link" },
            [
              _c(
                "router-link",
                { attrs: { to: "/page/" + _vm.entryData.Json.EntityPageID } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("global.more")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__$2;
//# sourceMappingURL=EntityEntry.js.map
